export default __webpack_public_path__ + "static/media/manualservice.496e5a4b.png";